/* ============================================================================
 * รายการโปรดของเว็บฝั่งลูกค้า — เก็บไว้ที่เครื่องผู้ใช้ (localStorage)
 *
 * ยังไม่มีระบบสมาชิกฝั่งลูกค้า (ดู HomeNavbar) หลังบ้านจึงไม่มีทางรู้ว่าใครกดหัวใจ
 * ระหว่างนี้จึงเก็บไว้ที่เบราว์เซอร์ก่อน แลกกับข้อจำกัดที่ต้องยอมรับ :
 * ผูกกับเครื่อง/เบราว์เซอร์เครื่องนั้น ล้าง cache แล้วหาย และหลังบ้านมองไม่เห็น
 *
 * เก็บเป็น "uid ของประกาศ" ไม่ใช่ id ที่รันตามลำดับ เพราะต้องเอาไปขอข้อมูลจริง
 * กลับมาผ่าน GET home/properties?uids=... (ฝั่งเว็บลูกค้า item.id คือ uid อยู่แล้ว)
 *
 * เรียงจากที่กดล่าสุดไปเก่าสุด — หน้ารายการโปรดใช้ลำดับนี้โดยตรง เพราะ API
 * เรียงตามเงื่อนไขของตัวเอง (ยอดเข้าชม/วันที่ประกาศ) ไม่รู้จักลำดับการกดของผู้ใช้
 *
 * ทุกจุดที่แก้ข้อมูลจะยิง event ให้หน้าอื่นรู้ตัว 2 ทาง
 *   - แท็บเดียวกัน : CustomEvent ของเราเอง (storage event ไม่ยิงให้แท็บที่เขียน)
 *   - ข้ามแท็บ     : storage event ของเบราว์เซอร์ — จำเป็น เพราะปุ่มรายการโปรด
 *                    เปิดหน้าใหม่เป็นอีกแท็บ ลบทิ้งที่นั่นแล้วแท็บเดิมต้องอัปเดตตาม
 * ========================================================================== */

const KEY = "mn-home-fav";
const EVENT = "mn-home-fav-change";

/* localStorage โยน error ได้จริงในโหมดไม่ระบุตัวตนของบางเบราว์เซอร์ และค่าใน
   นั้นผู้ใช้แก้เองได้ — อ่านพังเมื่อไรถือว่า "ยังไม่มีรายการโปรด" ไม่ใช่ทำหน้าพัง */
const read = () => {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(value) ? value.filter((uid) => typeof uid === "string" && uid) : [];
  } catch (e) {
    return [];
  }
};

const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {}
  window.dispatchEvent(new CustomEvent(EVENT));
  return list;
};

/** uid ทั้งหมดที่บันทึกไว้ เรียงจากที่กดล่าสุด */
export const favList = () => read();

/** รูปแบบ { [uid]: true } — ตรงกับ prop favorites ที่การ์ดทรัพย์ใช้อยู่เดิม */
export const favMap = () => read().reduce((map, uid) => ({ ...map, [uid]: true }), {});

export const favCount = () => read().length;

/** สลับสถานะหัวใจ 1 รายการ — คืนค่าสถานะใหม่ (true = อยู่ในรายการโปรดแล้ว) */
export const favToggle = (uid) => {
  if (!uid) return false;

  const list = read();
  const saved = list.includes(uid);
  // กดเพิ่มแล้วขึ้นหัวแถว ผู้ใช้จะได้เห็นของที่เพิ่งบันทึกก่อนเมื่อเปิดหน้ารายการโปรด
  write(saved ? list.filter((item) => item !== uid) : [uid, ...list]);
  return !saved;
};

/** นำออกหลายรายการพร้อมกัน — ใช้ล้าง uid ของประกาศที่ถูกปิดไปแล้ว */
export const favRemove = (uids = []) => {
  if (!uids.length) return;
  const drop = new Set(uids);
  write(read().filter((uid) => !drop.has(uid)));
};

export const favClear = () => write([]);

/** รับรู้ทุกครั้งที่รายการโปรดเปลี่ยน — คืนฟังก์ชันสำหรับเลิกฟัง (เรียกใน componentWillUnmount) */
export const favSubscribe = (onChange) => {
  const onStorage = (event) => {
    // event.key เป็น null ตอนผู้ใช้ล้าง storage ทั้งก้อน ต้องอัปเดตตามด้วย
    if (event.key === null || event.key === KEY) onChange();
  };

  window.addEventListener(EVENT, onChange);
  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener(EVENT, onChange);
    window.removeEventListener("storage", onStorage);
  };
};
